module.exports = __webpack_public_path__ + "img/full-darkwaters-3.8ccd1cd6.jpg";